import { MedicalInformation, MedicalInformationQuery } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, StandardSpinner } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { medicalInformationTranslationKeys } from '../../../../translations';

type MedicalInformationDetailsModalLoaderRenderProps = {
   medicalInformation: MedicalInformation;
};

type MedicalInformationDetailsModalLoaderProps = {
   readonly medicalInformationId: number;
   readonly children: (renderProps: MedicalInformationDetailsModalLoaderRenderProps) => JSX.Element;
};

export const MedicalInformationDetailsModalLoader = (
   props: MedicalInformationDetailsModalLoaderProps
): JSX.Element | null => {
   const {
      data: medicalInformation,
      loading: medicalInformationLoading,
      error: medicalInformationError,
   } = useCqrsGet<MedicalInformation>(() => {
      const query = new MedicalInformationQuery();
      query.id = Slot.of(props.medicalInformationId);
      query.showRemoved = true;
      return query;
   });

   if (medicalInformationLoading) {
      return <StandardSpinner />;
   }

   if (medicalInformationError) {
      dispatchSnackbarNegativeEvent(medicalInformationTranslationKeys.failedToFetchMedicalInformation);
      return null;
   }

   return props.children({
      medicalInformation: medicalInformation,
   });
};
